<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 22.4 28.35" xmlns="http://www.w3.org/2000/svg"
	><path
		d="M15.8 5.79c-2.09-1.53-2.9-3.22-3.22-4.43-.25-.97-.12-1.07-.12-1.07-.01-.12-.09-.21-.21-.26a.36.36 0 0 0-.35.03s-.4.08-1.06.67c-1.5 1.34-3.2 3.57-2.08 6.62 1.2 3.27.57 3.96-.06 3.91-.82-.06-.94-.52-.81-1.95.15-1.68-1.51-3.11-1.51-3.11S3.8 9.96 1.8 12.64C.61 14.23.04 16.25.04 18.09H0c0 5.66 5.01 10.26 11.18 10.26s11.18-4.59 11.18-10.26c.42-4.92-2.49-9.31-6.56-12.3m-4.6 19.67c-3.41 0-6.17-2.53-6.17-5.66 0-1.06.32-2.06.88-2.91.48 1.64 2.11 2.84 4.04 2.84 2.31 0 4.19-1.72 4.19-3.84 0-.4-.07-.79-.2-1.16 2.03.93 3.43 2.85 3.43 5.07 0 3.12-2.76 5.66-6.17 5.66"
	/></svg
>
